/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type Shimmer2018Page_viewer$ref = any;
export type queries_Shimmer2018Page_QueryVariables = {};
export type queries_Shimmer2018Page_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": Shimmer2018Page_viewer$ref;
    }) | null;
};
export type queries_Shimmer2018Page_Query = {
    readonly response: queries_Shimmer2018Page_QueryResponse;
    readonly variables: queries_Shimmer2018Page_QueryVariables;
};



/*
query queries_Shimmer2018Page_Query {
  viewer {
    id
    ...Shimmer2018Page_viewer
  }
}

fragment Shimmer2018Page_viewer on Viewer {
  id
  ...Shimmer2018_viewer
}

fragment Shimmer2018_viewer on Viewer {
  ...ProductPromotionBanner_viewer
}

fragment ProductPromotionBanner_viewer on Viewer {
  id
  isLoggedIn
  user {
    id
    ...ImageGallery_user
    ...AuthDialog_user
    email
    cart {
      id
      eventId
      event {
        id
        trinityPartyType
      }
      taxRate
      taxTotal
      totalNumberOfItems
      subTotalPriceOfItems
      promoCodeSavings
      viaQualifiedCartTotal
      subTotalPriceOfItemsWithPromoCodes
      promoCodes {
        code
        id
      }
      entries(first: 1000) {
        edges {
          node {
            id
            product {
              id
              productId
              price
              priceSale
              promoCodeDiscount {
                case4Cause {
                  case12PriceUSD
                  case6PriceUSD
                }
              }
            }
            quantity
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
  productsBulk(first: 8, productIds: ["b4210b34-0c4d-4e6d-8e96-12cb61340790", "175d0511-7951-4aea-a6a8-ac16ebfb2371", "d9d7b9c4-28b1-4ef4-8cc1-e63489d2a5bb", "791b3d82-4fad-4466-8511-bc1afbe026b8", "89416889-2235-4497-af34-a25ad9ad5434", "569b016d-aee4-4196-8dd9-526cdba57e22", "5ea58838-ac34-4d14-9db7-999a696e6a5e", "101b194b-106f-4f2c-89eb-f5109fc966b8", "bcd13c84-9e2d-4b87-b8cc-ef4bbbd8f426", "fc0ad9b7-a5f9-4d6f-93e9-e6d77d549711"]) {
    edges {
      node {
        id
        productId
        company
        category
        reviewTotal
        reviewAverage
        hasUserReviews
        priceSale
        optionsId
        optionName
        parentProduct
        productURLslug
        images {
          productCatalog
          id
        }
        content {
          summary
          foodPairings(first: 10) {
            edges {
              node {
                id
                title
                description
              }
            }
          }
          tasteProfile {
            body
            acidity
            tannins
            sweetness
            id
          }
          id
        }
        options {
          id
          optionId
          optionName
          label
          products {
            productId
            name
            optionName
            productURLslug
            id
          }
          options {
            id
            optionId
            optionName
            label
            products {
              productId
              optionName
              productURLslug
              id
            }
          }
        }
        promoCodeDiscount {
          case4Cause {
            case12PriceUSD
            case6PriceUSD
            case12SKU
            case6SKU
            donationEligible
          }
        }
        price
        inventorySKU
        inventoryQuantity
        name
        ...ProductListItem_product
      }
    }
  }
}

fragment ImageGallery_user on User {
  ...ProductListItem_user
  role
  conciergeCustomerAccountId
  conciergeUser {
    userId
    permissions {
      id
      oneCommerce {
        id
        preferredCustomer {
          access
        }
      }
    }
    id
  }
  permissions {
    id
    oneCommerce {
      id
      ceo {
        access
      }
      preferredCustomer {
        access
      }
    }
  }
  cartV2 {
    id
    cartId
    autoShipEnabled
    autoShipIntervalUnit
    autoShipIntervalCount
    promoCodeSavings
    saleSavings
    canSubscribeForAutoShip
    discountQualifiedCartTotal
    subTotalPriceOfItems
    subTotalPriceOfItemsWithDiscount
    total
    totalSavings
    totalNumberOfItems
    eventId
    eventHostFirstName
    event {
      id
      eventId
      trinityPartyType
    }
    promoCodes {
      id
      code
      promoDescription
      thresholds {
        discountAmount
        discountAmountEach
      }
    }
    wordPressCoupons {
      code
      couponDescription
      storeBalance
      yotpoCouponCode
      id
    }
    wordPressCouponSavings
    entries(first: 1000) {
      edges {
        node {
          id
          sku
          productId
          quantity
          productName
          productURLslug
          productImageUrl
          wineBottleQuantity
          isWinePack
          priceOriginal
          priceSale
          priceDiscount
          discountEligible
          priceDiscountPercent
          hasQualifyingDiscount
        }
      }
    }
  }
}

fragment AuthDialog_user on User {
  id
  role
  email
  lastName
  firstName
  hasSSOAccount
  shoppingWithCeoUser {
    userId
    id
  }
  cart {
    id
    eventId
    eventHostFirstName
  }
}

fragment ProductListItem_product on Product {
  id
  isSubscription
  productPermissions {
    oneCommerce {
      preferredCustomer {
        view
        add
      }
      default {
        view
        add
      }
    }
  }
  ranking
  company
  freeUpsGroundShipping
  productId
  name
  category
  price
  priceUSDmin
  priceUSDmax
  year
  priceSale
  reviewAverage
  productURLslug
  parentProduct
  inventoryText
  reviewTotal
  staticUrl
  images {
    productCatalog
    squareFront
    id
  }
  content {
    impactSmall
    summary
    id
  }
  promoCodeDiscount {
    case4Cause {
      case12PriceUSD
      case6PriceUSD
      case6SKU
      case12SKU
      donationEligible
    }
  }
  inventoryClass
  inventorySKU
  inventoryQuantity
}

fragment ProductListItem_user on User {
  id
  role
  conciergeCustomerAccountId
  conciergeUser {
    id
    userId
    permissions {
      id
      oneCommerce {
        id
        preferredCustomer {
          access
        }
      }
    }
    subscriptions {
      wineClub {
        enrollmentStatus
        subscriptionStatus
        id
      }
      id
    }
  }
  cartV2 {
    id
    cartId
    discountQualifiedCartTotal
    entries(first: 1000) {
      edges {
        node {
          id
          sku
          productId
          quantity
          productName
          productURLslug
          productImageUrl
          wineBottleQuantity
          isWinePack
          priceOriginal
          priceSale
          priceDiscount
          discountEligible
          priceDiscountPercent
          hasQualifyingDiscount
        }
      }
    }
  }
  subscriptions {
    wineClub {
      enrollmentStatus
      subscriptionStatus
      id
    }
    id
  }
  permissions {
    id
    oneCommerce {
      id
      preferredCustomer {
        access
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "access",
            "args": null,
            "storageKey": null
        } as any)
    ], v2 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "preferredCustomer",
        "storageKey": null,
        "args": null,
        "concreteType": "AccessType",
        "plural": false,
        "selections": (v1 /*: any*/)
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "userId",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "subscriptions",
        "storageKey": null,
        "args": null,
        "concreteType": "Subscriptions",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "wineClub",
                "storageKey": null,
                "args": null,
                "concreteType": "WineClubType",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "enrollmentStatus",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "subscriptionStatus",
                        "args": null,
                        "storageKey": null
                    },
                    (v0 /*: any*/)
                ]
            },
            (v0 /*: any*/)
        ]
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "subTotalPriceOfItems",
        "args": null,
        "storageKey": null
    } as any), v6 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 1000,
            "type": "Int"
        } as any)
    ], v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productId",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "quantity",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productURLslug",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "priceSale",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "promoCodeSavings",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "totalNumberOfItems",
        "args": null,
        "storageKey": null
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "eventId",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "eventHostFirstName",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "trinityPartyType",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "price",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "case12PriceUSD",
        "args": null,
        "storageKey": null
    } as any), v19 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "case6PriceUSD",
        "args": null,
        "storageKey": null
    } as any), v20 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "optionName",
        "args": null,
        "storageKey": null
    } as any), v21 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "optionId",
        "args": null,
        "storageKey": null
    } as any), v22 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "label",
        "args": null,
        "storageKey": null
    } as any), v23 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v24 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "view",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "add",
            "args": null,
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "queries_Shimmer2018Page_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "Shimmer2018Page_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "queries_Shimmer2018Page_Query",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isLoggedIn",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "permissions",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PermissionsType",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "oneCommerce",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "OneCommerceType",
                                            "plural": false,
                                            "selections": [
                                                (v0 /*: any*/),
                                                (v2 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "ceo",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "AccessType",
                                                    "plural": false,
                                                    "selections": (v1 /*: any*/)
                                                }
                                            ]
                                        }
                                    ]
                                },
                                (v0 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "conciergeCustomerAccountId",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "conciergeUser",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        (v3 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "permissions",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PermissionsType",
                                            "plural": false,
                                            "selections": [
                                                (v0 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "oneCommerce",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "OneCommerceType",
                                                    "plural": false,
                                                    "selections": [
                                                        (v0 /*: any*/),
                                                        (v2 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        (v4 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "cartV2",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "CartV2",
                                    "plural": false,
                                    "selections": [
                                        (v5 /*: any*/),
                                        (v0 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "discountQualifiedCartTotal",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "entries",
                                            "storageKey": "entries(first:1000)",
                                            "args": (v6 /*: any*/),
                                            "concreteType": "CartEntryV3Connection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "CartEntryV3Edge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "CartEntryV3",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "wineBottleQuantity",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v0 /*: any*/),
                                                                (v7 /*: any*/),
                                                                (v8 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "productName",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v9 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "productImageUrl",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "sku",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "isWinePack",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "priceOriginal",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v10 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "priceDiscount",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "discountEligible",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "priceDiscountPercent",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "hasQualifyingDiscount",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "autoShipEnabled",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "autoShipIntervalUnit",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "autoShipIntervalCount",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v11 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "saleSavings",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "canSubscribeForAutoShip",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "cartId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "subTotalPriceOfItemsWithDiscount",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "total",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "totalSavings",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v12 /*: any*/),
                                        (v13 /*: any*/),
                                        (v14 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "event",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Event",
                                            "plural": false,
                                            "selections": [
                                                (v0 /*: any*/),
                                                (v13 /*: any*/),
                                                (v15 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "promoCodes",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PromoCode",
                                            "plural": true,
                                            "selections": [
                                                (v0 /*: any*/),
                                                (v16 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "promoDescription",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "thresholds",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PromoCodeThresholds",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "discountAmount",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "discountAmountEach",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "wordPressCoupons",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "WordPressCoupon",
                                            "plural": true,
                                            "selections": [
                                                (v16 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "couponDescription",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "storeBalance",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "yotpoCouponCode",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v0 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "wordPressCouponSavings",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                (v4 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "role",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "email",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "lastName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "firstName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hasSSOAccount",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shoppingWithCeoUser",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v3 /*: any*/),
                                        (v0 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "cart",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Cart",
                                    "plural": false,
                                    "selections": [
                                        (v12 /*: any*/),
                                        (v0 /*: any*/),
                                        (v14 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "event",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Event",
                                            "plural": false,
                                            "selections": [
                                                (v0 /*: any*/),
                                                (v15 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "taxRate",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "taxTotal",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v13 /*: any*/),
                                        (v5 /*: any*/),
                                        (v11 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "viaQualifiedCartTotal",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "subTotalPriceOfItemsWithPromoCodes",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "promoCodes",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PromoCode",
                                            "plural": true,
                                            "selections": [
                                                (v16 /*: any*/),
                                                (v0 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "entries",
                                            "storageKey": "entries(first:1000)",
                                            "args": (v6 /*: any*/),
                                            "concreteType": "CartEntryV3Connection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "CartEntryV3Edge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "CartEntryV3",
                                                            "plural": false,
                                                            "selections": [
                                                                (v0 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "product",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Product",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v0 /*: any*/),
                                                                        (v7 /*: any*/),
                                                                        (v17 /*: any*/),
                                                                        (v10 /*: any*/),
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "promoCodeDiscount",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "PromoCodeDiscount",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "alias": null,
                                                                                    "name": "case4Cause",
                                                                                    "storageKey": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Case4Cause",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v18 /*: any*/),
                                                                                        (v19 /*: any*/)
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                (v8 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "__typename",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "cursor",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "pageInfo",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "endCursor",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "hasNextPage",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedHandle",
                                            "alias": null,
                                            "name": "entries",
                                            "args": (v6 /*: any*/),
                                            "handle": "connection",
                                            "key": "Cart_entries",
                                            "filters": null
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "productsBulk",
                            "storageKey": "productsBulk(first:8,productIds:[\"b4210b34-0c4d-4e6d-8e96-12cb61340790\",\"175d0511-7951-4aea-a6a8-ac16ebfb2371\",\"d9d7b9c4-28b1-4ef4-8cc1-e63489d2a5bb\",\"791b3d82-4fad-4466-8511-bc1afbe026b8\",\"89416889-2235-4497-af34-a25ad9ad5434\",\"569b016d-aee4-4196-8dd9-526cdba57e22\",\"5ea58838-ac34-4d14-9db7-999a696e6a5e\",\"101b194b-106f-4f2c-89eb-f5109fc966b8\",\"bcd13c84-9e2d-4b87-b8cc-ef4bbbd8f426\",\"fc0ad9b7-a5f9-4d6f-93e9-e6d77d549711\"])",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 8,
                                    "type": "Int"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "productIds",
                                    "value": [
                                        "b4210b34-0c4d-4e6d-8e96-12cb61340790",
                                        "175d0511-7951-4aea-a6a8-ac16ebfb2371",
                                        "d9d7b9c4-28b1-4ef4-8cc1-e63489d2a5bb",
                                        "791b3d82-4fad-4466-8511-bc1afbe026b8",
                                        "89416889-2235-4497-af34-a25ad9ad5434",
                                        "569b016d-aee4-4196-8dd9-526cdba57e22",
                                        "5ea58838-ac34-4d14-9db7-999a696e6a5e",
                                        "101b194b-106f-4f2c-89eb-f5109fc966b8",
                                        "bcd13c84-9e2d-4b87-b8cc-ef4bbbd8f426",
                                        "fc0ad9b7-a5f9-4d6f-93e9-e6d77d549711"
                                    ],
                                    "type": "[String]"
                                }
                            ],
                            "concreteType": "ProductConnection",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ProductEdge",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Product",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "promoCodeDiscount",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PromoCodeDiscount",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "case4Cause",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Case4Cause",
                                                            "plural": false,
                                                            "selections": [
                                                                (v18 /*: any*/),
                                                                (v19 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "case12SKU",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "case6SKU",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "donationEligible",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                (v0 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "company",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "category",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "reviewTotal",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "reviewAverage",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "hasUserReviews",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v10 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "optionsId",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v20 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "parentProduct",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v9 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "images",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Images",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "productCatalog",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v0 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "squareFront",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "content",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Content",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "summary",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "foodPairings",
                                                            "storageKey": "foodPairings(first:10)",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "first",
                                                                    "value": 10,
                                                                    "type": "Int"
                                                                }
                                                            ],
                                                            "concreteType": "FoodPairingsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "edges",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "FoodPairingsEdge",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "node",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "FoodPairings",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v0 /*: any*/),
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "alias": null,
                                                                                    "name": "title",
                                                                                    "args": null,
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "alias": null,
                                                                                    "name": "description",
                                                                                    "args": null,
                                                                                    "storageKey": null
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "tasteProfile",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "TasteProfile",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "body",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "acidity",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "tannins",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "sweetness",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v0 /*: any*/)
                                                            ]
                                                        },
                                                        (v0 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "impactSmall",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "options",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ProductOptions",
                                                    "plural": false,
                                                    "selections": [
                                                        (v0 /*: any*/),
                                                        (v21 /*: any*/),
                                                        (v20 /*: any*/),
                                                        (v22 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "products",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Product",
                                                            "plural": true,
                                                            "selections": [
                                                                (v7 /*: any*/),
                                                                (v23 /*: any*/),
                                                                (v20 /*: any*/),
                                                                (v9 /*: any*/),
                                                                (v0 /*: any*/)
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "options",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ProductOptions",
                                                            "plural": true,
                                                            "selections": [
                                                                (v0 /*: any*/),
                                                                (v21 /*: any*/),
                                                                (v20 /*: any*/),
                                                                (v22 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "products",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Product",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        (v7 /*: any*/),
                                                                        (v20 /*: any*/),
                                                                        (v9 /*: any*/),
                                                                        (v0 /*: any*/)
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                (v7 /*: any*/),
                                                (v17 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "inventorySKU",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "inventoryQuantity",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v23 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "isSubscription",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "productPermissions",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ProductPermissions",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "oneCommerce",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "AppProductPermissionsAccess",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "preferredCustomer",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "ProductPermissionsAccess",
                                                                    "plural": false,
                                                                    "selections": (v24 /*: any*/)
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "default",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "ProductPermissionsAccess",
                                                                    "plural": false,
                                                                    "selections": (v24 /*: any*/)
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "ranking",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "freeUpsGroundShipping",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "priceUSDmin",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "priceUSDmax",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "year",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "inventoryText",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "staticUrl",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "inventoryClass",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "queries_Shimmer2018Page_Query",
            "id": null,
            "text": "query queries_Shimmer2018Page_Query {\n  viewer {\n    id\n    ...Shimmer2018Page_viewer\n  }\n}\n\nfragment Shimmer2018Page_viewer on Viewer {\n  id\n  ...Shimmer2018_viewer\n}\n\nfragment Shimmer2018_viewer on Viewer {\n  ...ProductPromotionBanner_viewer\n}\n\nfragment ProductPromotionBanner_viewer on Viewer {\n  id\n  isLoggedIn\n  user {\n    id\n    ...ImageGallery_user\n    ...AuthDialog_user\n    email\n    cart {\n      id\n      eventId\n      event {\n        id\n        trinityPartyType\n      }\n      taxRate\n      taxTotal\n      totalNumberOfItems\n      subTotalPriceOfItems\n      promoCodeSavings\n      viaQualifiedCartTotal\n      subTotalPriceOfItemsWithPromoCodes\n      promoCodes {\n        code\n        id\n      }\n      entries(first: 1000) {\n        edges {\n          node {\n            id\n            product {\n              id\n              productId\n              price\n              priceSale\n              promoCodeDiscount {\n                case4Cause {\n                  case12PriceUSD\n                  case6PriceUSD\n                }\n              }\n            }\n            quantity\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n  productsBulk(first: 8, productIds: [\"b4210b34-0c4d-4e6d-8e96-12cb61340790\", \"175d0511-7951-4aea-a6a8-ac16ebfb2371\", \"d9d7b9c4-28b1-4ef4-8cc1-e63489d2a5bb\", \"791b3d82-4fad-4466-8511-bc1afbe026b8\", \"89416889-2235-4497-af34-a25ad9ad5434\", \"569b016d-aee4-4196-8dd9-526cdba57e22\", \"5ea58838-ac34-4d14-9db7-999a696e6a5e\", \"101b194b-106f-4f2c-89eb-f5109fc966b8\", \"bcd13c84-9e2d-4b87-b8cc-ef4bbbd8f426\", \"fc0ad9b7-a5f9-4d6f-93e9-e6d77d549711\"]) {\n    edges {\n      node {\n        id\n        productId\n        company\n        category\n        reviewTotal\n        reviewAverage\n        hasUserReviews\n        priceSale\n        optionsId\n        optionName\n        parentProduct\n        productURLslug\n        images {\n          productCatalog\n          id\n        }\n        content {\n          summary\n          foodPairings(first: 10) {\n            edges {\n              node {\n                id\n                title\n                description\n              }\n            }\n          }\n          tasteProfile {\n            body\n            acidity\n            tannins\n            sweetness\n            id\n          }\n          id\n        }\n        options {\n          id\n          optionId\n          optionName\n          label\n          products {\n            productId\n            name\n            optionName\n            productURLslug\n            id\n          }\n          options {\n            id\n            optionId\n            optionName\n            label\n            products {\n              productId\n              optionName\n              productURLslug\n              id\n            }\n          }\n        }\n        promoCodeDiscount {\n          case4Cause {\n            case12PriceUSD\n            case6PriceUSD\n            case12SKU\n            case6SKU\n            donationEligible\n          }\n        }\n        price\n        inventorySKU\n        inventoryQuantity\n        name\n        ...ProductListItem_product\n      }\n    }\n  }\n}\n\nfragment ImageGallery_user on User {\n  ...ProductListItem_user\n  role\n  conciergeCustomerAccountId\n  conciergeUser {\n    userId\n    permissions {\n      id\n      oneCommerce {\n        id\n        preferredCustomer {\n          access\n        }\n      }\n    }\n    id\n  }\n  permissions {\n    id\n    oneCommerce {\n      id\n      ceo {\n        access\n      }\n      preferredCustomer {\n        access\n      }\n    }\n  }\n  cartV2 {\n    id\n    cartId\n    autoShipEnabled\n    autoShipIntervalUnit\n    autoShipIntervalCount\n    promoCodeSavings\n    saleSavings\n    canSubscribeForAutoShip\n    discountQualifiedCartTotal\n    subTotalPriceOfItems\n    subTotalPriceOfItemsWithDiscount\n    total\n    totalSavings\n    totalNumberOfItems\n    eventId\n    eventHostFirstName\n    event {\n      id\n      eventId\n      trinityPartyType\n    }\n    promoCodes {\n      id\n      code\n      promoDescription\n      thresholds {\n        discountAmount\n        discountAmountEach\n      }\n    }\n    wordPressCoupons {\n      code\n      couponDescription\n      storeBalance\n      yotpoCouponCode\n      id\n    }\n    wordPressCouponSavings\n    entries(first: 1000) {\n      edges {\n        node {\n          id\n          sku\n          productId\n          quantity\n          productName\n          productURLslug\n          productImageUrl\n          wineBottleQuantity\n          isWinePack\n          priceOriginal\n          priceSale\n          priceDiscount\n          discountEligible\n          priceDiscountPercent\n          hasQualifyingDiscount\n        }\n      }\n    }\n  }\n}\n\nfragment AuthDialog_user on User {\n  id\n  role\n  email\n  lastName\n  firstName\n  hasSSOAccount\n  shoppingWithCeoUser {\n    userId\n    id\n  }\n  cart {\n    id\n    eventId\n    eventHostFirstName\n  }\n}\n\nfragment ProductListItem_product on Product {\n  id\n  isSubscription\n  productPermissions {\n    oneCommerce {\n      preferredCustomer {\n        view\n        add\n      }\n      default {\n        view\n        add\n      }\n    }\n  }\n  ranking\n  company\n  freeUpsGroundShipping\n  productId\n  name\n  category\n  price\n  priceUSDmin\n  priceUSDmax\n  year\n  priceSale\n  reviewAverage\n  productURLslug\n  parentProduct\n  inventoryText\n  reviewTotal\n  staticUrl\n  images {\n    productCatalog\n    squareFront\n    id\n  }\n  content {\n    impactSmall\n    summary\n    id\n  }\n  promoCodeDiscount {\n    case4Cause {\n      case12PriceUSD\n      case6PriceUSD\n      case6SKU\n      case12SKU\n      donationEligible\n    }\n  }\n  inventoryClass\n  inventorySKU\n  inventoryQuantity\n}\n\nfragment ProductListItem_user on User {\n  id\n  role\n  conciergeCustomerAccountId\n  conciergeUser {\n    id\n    userId\n    permissions {\n      id\n      oneCommerce {\n        id\n        preferredCustomer {\n          access\n        }\n      }\n    }\n    subscriptions {\n      wineClub {\n        enrollmentStatus\n        subscriptionStatus\n        id\n      }\n      id\n    }\n  }\n  cartV2 {\n    id\n    cartId\n    discountQualifiedCartTotal\n    entries(first: 1000) {\n      edges {\n        node {\n          id\n          sku\n          productId\n          quantity\n          productName\n          productURLslug\n          productImageUrl\n          wineBottleQuantity\n          isWinePack\n          priceOriginal\n          priceSale\n          priceDiscount\n          discountEligible\n          priceDiscountPercent\n          hasQualifyingDiscount\n        }\n      }\n    }\n  }\n  subscriptions {\n    wineClub {\n      enrollmentStatus\n      subscriptionStatus\n      id\n    }\n    id\n  }\n  permissions {\n    id\n    oneCommerce {\n      id\n      preferredCustomer {\n        access\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'e32c326c19ae7e50a0bcfadeb6888975';
export default node;
